<!--
  ProgressBar — "Étape X/N" stepper bar. Presentational, no emits, no internal state.
    visible    show / hide
    current    current step (1-indexed)
    total      total step count
    showTotal  show the "/ total" suffix (false until the path is known, to
               avoid the denominator jumping when the role is chosen)
    pct        fill percentage (0-100)
    stepLabel  word before the step number
    doneLabel  accessible name of the check shown at 100%
  The classes are deliberately not Bootstrap's `progress-bar`, whose global layout rules
  would leak in wherever Bootstrap CSS is loaded.
-->
<template>
  <div v-if="visible" class="step-progress">
    <div class="step-progress-track">
      <div class="step-progress-fill" :style="{ width: pct + '%' }" />
    </div>
    <div class="step-progress-label">
      {{ stepLabel }} {{ current }}<template v-if="showTotal"> / {{ total }}</template>
      <span v-if="pct >= 100" class="step-progress-check" :aria-label="doneLabel">✓</span>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    visible?: boolean
    current: number
    total: number
    showTotal?: boolean
    pct: number
    stepLabel?: string
    doneLabel?: string
  }>(),
  { visible: true, showTotal: true, stepLabel: 'Étape', doneLabel: 'terminé' },
)
</script>

<style scoped>
.step-progress {
  flex-shrink: 0;
  padding: 10px 20px 8px;
  background: var(--white);
  border-bottom: 1px solid #f0f5f9; /* off-palette — DS pass to arbitrate */
}
.step-progress-track {
  height: 5px;
  background: #f0f5f9; /* off-palette — DS pass to arbitrate */
  border-radius: 3px;
  overflow: hidden;
}
.step-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--brand-default) 0%, var(--blue-800) 100%);
  border-radius: 3px;
  transition: width 0.4s cubic-bezier(0.2, 0.6, 0.4, 1);
}
.step-progress-label {
  font-size: 10.5px;
  font-weight: 700;
  color: var(--grey-500);
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: right;
  margin-top: 5px;
}
.step-progress-check {
  color: #38d39f; /* off-palette success green — DS pass to arbitrate */
  margin-left: 4px;
  letter-spacing: 0;
}
@media (prefers-reduced-motion: reduce) {
  .step-progress-fill {
    transition: none;
  }
}
</style>
